export const MAILGUN_BLOCK_SCOPE_MARKER = 'mailgun';
